import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useDisciplina } from 'features/live/liveNav/hooks';
import { selectIsLiveNavLoading } from 'features/live/liveNav/selectors';
import { useTypedSelector } from 'lib/centralStore';
import { isServerSide } from 'utility/constant';
import styles from './Counter.module.scss';

export interface CounterProps {
  idDisciplina: string;
  isLive?: boolean | Boolean;
  isVirtual?: boolean | Boolean;
  counter?: number | Number;
  className?: string;
}

const _Loader = ({ idDisciplina, className }: CounterProps): JSX.Element => {
  return (
    <span
      key={`loader_${idDisciplina}`}
      suppressHydrationWarning
      className={classNames(className ? className : styles.livesNow)}
    >
      -
    </span>
  );
};

const _Counter = ({ counter, isVirtual, idDisciplina, className }: CounterProps): JSX.Element => {
  const label = isVirtual ? 'VR' : counter?.toFixed(0);
  const isHidden = isVirtual ? false : counter === 0;

  return (
    <span
      suppressHydrationWarning
      key={`live-counter-${idDisciplina}`}
      className={classNames(className ? className : styles.livesNow, { [styles.hidden]: isHidden })}
    >
      {label}
    </span>
  );
};

export const Counter = (props: CounterProps) => {
  const { isLive, idDisciplina } = props ?? {};
  const isLiveNavLoading = useTypedSelector(selectIsLiveNavLoading);
  const { isRoot, counter, isVirtual } = useDisciplina(idDisciplina, isLive);

  // if(counter > 0){ console.log(`Counter #${descrizione}# isRoot=${isRoot}# idDisciplina=${idDisciplina}# isLive=${isLive}# isVirtual=${isVirtual}# counter=${counter}`) }

  let skip = useMemo(() => {
    let result = isRoot;
    if (isVirtual) {
      result = false;
    }
    if (!isLive) {
      result = true;
    }
    return result;
  }, [isLive, isRoot, isVirtual]);

  if (skip) {
    return <React.Fragment key={`counter-${idDisciplina}-${isLive}-${counter}`} />;
  }

  if (isServerSide || isLiveNavLoading) {
    return _Loader(props);
  }

  return _Counter({ ...props, counter, isVirtual });
};